module.exports = __webpack_public_path__ + "static/media/saraya-3.73dce086.jpg";